// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.astaColorImg {\r\n  clip-path: url(#myImg);\n}\n.st0 {\r\n  fill: none;\r\n  stroke: #020203;\r\n  stroke-width: 0.15;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\n}\n.white {\r\n  text-shadow: 0 0 0px black;\n}\n.nocolore {\r\n  text-shadow: 0 0 2px black;\n}\n.asta-dx-ext-text {\r\n  font-size: 10px;\r\n  text-align: right;\n}\r\n", ""]);
// Exports
module.exports = exports;
